import type { Block, CreateSnippetInput, UpdateSnippetInput } from '@emailforge/schemas';

import { apiSlice } from '@/features/api/apiSlice';

export type Snippet = {
  id: string;
  organizationId: string;
  name: string;
  description: string | null;
  category: string | null;
  blocksJson: Block[];
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
};

export const snippetsApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    listSnippets: b.query<Snippet[], void>({
      query: () => '/snippets',
      providesTags: (rows) =>
        rows
          ? [...rows.map((r) => ({ type: 'Snippet' as const, id: r.id })), { type: 'Snippet', id: 'LIST' }]
          : [{ type: 'Snippet', id: 'LIST' }],
    }),
    getSnippet: b.query<Snippet, string>({
      query: (id) => `/snippets/${id}`,
      providesTags: (_r, _e, id) => [{ type: 'Snippet', id }],
    }),
    createSnippet: b.mutation<Snippet, CreateSnippetInput>({
      query: (body) => ({ url: '/snippets', method: 'POST', body }),
      invalidatesTags: [{ type: 'Snippet', id: 'LIST' }],
    }),
    updateSnippet: b.mutation<Snippet, { id: string; patch: UpdateSnippetInput }>({
      query: ({ id, patch }) => ({ url: `/snippets/${id}`, method: 'PATCH', body: patch }),
      invalidatesTags: (_r, _e, { id }) => [{ type: 'Snippet', id }, { type: 'Snippet', id: 'LIST' }],
    }),
    deleteSnippet: b.mutation<void, string>({
      query: (id) => ({ url: `/snippets/${id}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'Snippet', id: 'LIST' }],
    }),
  }),
});

export const {
  useListSnippetsQuery,
  useGetSnippetQuery,
  useCreateSnippetMutation,
  useUpdateSnippetMutation,
  useDeleteSnippetMutation,
} = snippetsApi;
